import React from 'react';
import { notification} from 'antd';


export type NotificationProps = {
  status: string;
  message: any;
  description?: any;
  duration: number;
  className?: string
  placement:
  | 'top'
  | 'topLeft'
  | 'topRight'
  | 'bottom'
  | 'bottomLeft'
  | 'bottomRight';

};

const Notification = ({
  status,
  message,
  description,
  duration = 3,
  placement,
  className

}: NotificationProps) => {
  const importAll = (r: any) => {
    let images: any = {};
    r.keys().map((item: any, index: any) => {
      images[item.replace('./', '')] = r(item);
    });
    return images;
  };

  const images: any = importAll(
    require.context('/src/assets/', false, /\.(png|jpg|jpe?g|svg)$/)
  );
  console.log({ status });
  let icon;
  if (status === 'success') {
    icon = images['success.png'];
  } else if (status === 'error') {
    icon = images['warning.png'];
  }
  // const icon = status === 'success' ? <CheckCircleOutlined style={{ color: 'green', fontSize: '70px', margin: '0 auto' }} /> : <CloseCircleOutlined style={{ color: 'red', fontSize: '70px', margin: '0 auto' }} />;

  const closeNotification = () => {
    notification.destroy();
  };

  notification.open({
    message: (
      <div>
        <div
          style={{
            margin:'50px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
          }}
        >
          <img
            src={icon}
            style={{
              width: 140,
              height: 110,
            }}
          />
            <p className="font-weight-500 font-size-24">{message}</p>
            <p className="font-weight-500 font-size-15 mt-2">{description??''}</p>


        </div>
      </div>
    ),
    duration: duration,
    placement: "top",
    closeIcon: null,
    className: `ut-notif ${className}`,
    showProgress: false,
    key: message,
  });

  return null;
};

export default Notification;
